export default __webpack_public_path__ + "static/media/noBets.9949360c.mp3";